<template>
  <div v-if="deviceRevisionForm" class="py-8">
    <DeviceRevisionPropertiesForm :form="deviceRevisionForm" @on-save="confirmSave" @on-delete="confirmDelete"/>
  </div>
</template>

<script>
import {mapStores} from "pinia";
import DeviceRevisionPropertiesForm from "@/Forms/DeviceRevision/DeviceRevisionPropertiesForm.vue";
import {useDeviceRevisionsStore} from "@/stores/deviceRevisions.js";

export default {
  name: "DeviceRevisionPropertiesView",
  components: {DeviceRevisionPropertiesForm},
  data() {
    return {
      deviceRevisionForm: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  computed: {
    ...mapStores(useDeviceRevisionsStore)
  },
  methods: {
    confirmSave() {
      if (this.deviceRevisionForm?.regulation_ids.length > 0) {
        this.saveDeviceRevision();
      } else {
        this.$confirm.require({
          group: 'save',
          header: this.$t('pages.admin.devices.device_revisions.device_revision.properties.device_revision_properties_view.save_device_revision'),
          message: this.$t('pages.admin.devices.device_revisions.device_revision.properties.device_revision_properties_view.are_you_sure_you_want_to_save_this_device_revision'),

          accept: () => {
            this.saveDeviceRevision();
          },
          reject: () => {
            this.$toast.add({
              severity: 'info',
              summary: this.$t('common.cancelled'),
              detail: 'Device revision was not saved',
              life: 3000
            });
          }
        });
      }
    },
    async saveDeviceRevision() {
      try {
        const response = await this.deviceRevisionForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.devices.device_revisions.device_revision.properties.device_revision_properties_view.device_revision_saved'),
          life: 3000
        });
        this.$emit('on-save');
        this.$router.replace({params: {...this.$route.params, revision: response.data.id}});
      } catch (error) {
        //
      }
    },
    confirmDelete() {
      this.$confirm.require({
        group: 'delete',
        header: this.$t('pages.admin.devices.device_revisions.device_revision.properties.device_revision_properties_view.delete_device_revision'),
        message: this.$t('pages.admin.devices.device_revisions.device_revision.properties.device_revision_properties_view.are_you_sure_you_want_to_delete_this_device_revision'),
        accept: () => {
          this.deleteDeviceRevision();
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.devices.device_revisions.device_revision.properties.device_revision_properties_view.device_revision_was_not_deleted'),
            life: 3000
          });
        }
      });
    },
    async deleteDeviceRevision() {
      try {
        if (this.$route.params.revision !== 'NEW') {
          await this.deviceRevisionsStore.deleteDeviceRevision(this.$route.params.revision);
          this.$emit('on-delete');
        }
        this.$router.push({name: 'admin.devices.revisions', params: {...this.$route.params, revision: undefined}});
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    '$route.params.revision': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.revision === 'NEW') {
            this.deviceRevisionForm = await this.deviceRevisionsStore.createDeviceRevision();
          } else {
            this.deviceRevisionForm = await this.deviceRevisionsStore.editDeviceRevision(this.$route.params.revision);
            this.deviceRevisionForm.id =this.$route.params.revision;
          }
        } else {
          this.deviceRevisionForm = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>

<style scoped>

</style>
